import type React from 'react';

/** Kiwoom /dashboard 섹션 — 자주색(#7c3aed) · 검정 그라데이션 (Binance/IBKR과 동일 패턴) */
export const kiwoomSectionStyle: React.CSSProperties = {
  background: 'linear-gradient(145deg, #0d1117 0%, #14101a 38%, #1e1428 62%, #2a1838 100%)',
  border: '1px solid #7c3aed55',
  borderRadius: '12px',
  padding: '20px',
  marginBottom: '30px',
  boxShadow: 'inset 0 1px 0 #7c3aed18',
  maxWidth: '100%',
  minWidth: 0,
};

export const kiwoomCardStyle: React.CSSProperties = {
  background: 'rgba(45, 27, 63, 0.92)',
  border: '1px solid #8b5cf655',
  borderRadius: '12px',
  padding: '20px',
  marginBottom: '30px',
  maxWidth: '100%',
  minWidth: 0,
};

/** 피처 실행·틱 급등 등 인라인 패널 */
export const kiwoomInsetPanel: React.CSSProperties = {
  background: 'rgba(45, 27, 63, 0.92)',
  border: '1px solid #8b5cf655',
  borderRadius: '12px',
  padding: '12px 14px',
  marginBottom: 14,
  maxWidth: '100%',
  minWidth: 0,
  overflowX: 'auto',
};

export const kiwoomH2: React.CSSProperties = {
  color: '#f3e8ff',
  marginBottom: '16px',
  fontSize: '1rem',
  fontWeight: 600,
};

export const kiwoomH3: React.CSSProperties = {
  color: '#e9d5ff',
  marginBottom: '12px',
  fontSize: '0.9rem',
  fontWeight: 600,
};

export const kiwoomAccent = '#a371f7';
export const kiwoomAccentBright = '#c4a0ff';
export const kiwoomMuted = '#c4b5d4';
export const kiwoomSubtle = '#9ca3af';

/** Upbit — 파란색(상) · 흰색(하) 그라데이션 */
export const upbitSectionStyle: React.CSSProperties = {
  background: 'linear-gradient(145deg, #1e3a8a 0%, #3b82f6 32%, #eef6ff 74%, #ffffff 100%)',
  border: '1px solid #60a5fa55',
  borderRadius: '12px',
  padding: '20px',
  marginBottom: '30px',
  boxShadow: 'inset 0 1px 0 #ffffff50',
};

export const upbitH2: React.CSSProperties = {
  color: '#ffffff',
  marginBottom: '16px',
  fontSize: '1rem',
  fontWeight: 600,
  textShadow: '0 1px 10px #1e40af88',
};

export const upbitH3: React.CSSProperties = {
  color: '#eff6ff',
  marginBottom: '12px',
  fontSize: '0.9rem',
  fontWeight: 600,
  textShadow: '0 1px 6px #1e3a8a66',
};

export const upbitMuted = '#dbeafe';

export const upbitAccentBright = '#93c5fd';

export const upbitCardStyle: React.CSSProperties = {
  background: 'rgba(15, 23, 42, 0.72)',
  border: '1px solid #60a5fa44',
  borderRadius: '12px',
  padding: '20px',
  marginBottom: '30px',
};

/** Binance — 노란(#f0b90b) · 검정 그라데이션 */
export const binanceSectionStyle: React.CSSProperties = {
  background: 'linear-gradient(145deg, #0b0e11 0%, #12100a 38%, #1c1708 62%, #2a2206 100%)',
  border: '1px solid #f0b90b55',
  borderRadius: '12px',
  padding: '20px',
  marginBottom: '30px',
  boxShadow: 'inset 0 1px 0 #f0b90b18',
  maxWidth: '100%',
  minWidth: 0,
};

export const binanceH2: React.CSSProperties = {
  color: '#f0b90b',
  marginBottom: '16px',
  fontSize: '1rem',
  fontWeight: 600,
  textShadow: '0 0 24px #f0b90b33',
};

export const binanceH3: React.CSSProperties = {
  color: '#fcd535',
  marginBottom: '12px',
  fontSize: '0.9rem',
  fontWeight: 600,
};

export const binanceMuted = '#b7a882';

/** IBKR — red accent on dark */
export const ibkrSectionStyle: React.CSSProperties = {
  background: 'linear-gradient(145deg, #0d1117 0%, #161214 38%, #221418 62%, #2a181c 100%)',
  border: '1px solid #d8122255',
  borderRadius: '12px',
  padding: '20px',
  marginBottom: '30px',
  boxShadow: 'inset 0 1px 0 #d8122218',
  maxWidth: '100%',
  minWidth: 0,
};

export const ibkrH2: React.CSSProperties = {
  color: '#f87171',
  marginBottom: '16px',
  fontSize: '1rem',
  fontWeight: 600,
  textShadow: '0 0 24px #d8122233',
};

export const ibkrH3: React.CSSProperties = {
  color: '#fca5a5',
  marginBottom: '12px',
  fontSize: '0.9rem',
  fontWeight: 600,
};

export const ibkrMuted = '#c9a3a8';

/** Bithumb — brand orange #FF6C00 on dark (IBKR-red pattern; no yellow = not Binance) */
export const bithumbSectionStyle: React.CSSProperties = {
  background: 'linear-gradient(145deg, #0d1117 0%, #161210 38%, #221810 62%, #2a1c12 100%)',
  border: '1px solid #ff6c0055',
  borderRadius: '12px',
  padding: '20px',
  marginBottom: '30px',
  boxShadow: 'inset 0 1px 0 #ff6c0018',
  maxWidth: '100%',
  minWidth: 0,
};

export const bithumbH2: React.CSSProperties = {
  color: '#fb923c',
  marginBottom: '16px',
  fontSize: '1rem',
  fontWeight: 600,
  textShadow: '0 0 24px #ff6c0033',
};

export const bithumbH3: React.CSSProperties = {
  color: '#fdba74',
  marginBottom: '12px',
  fontSize: '0.9rem',
  fontWeight: 600,
};

export const bithumbMuted = '#c9aa98';
export const bithumbAccent = '#ff6c00';
export const bithumbAccentBright = '#fdba74';

export type ExchangeTheme = 'kiwoom' | 'upbit' | 'binance' | 'ibkr' | 'bithumb';

export function exchangeSectionStyle(theme: ExchangeTheme): React.CSSProperties {
  switch (theme) {
    case 'kiwoom':
      return kiwoomSectionStyle;
    case 'upbit':
      return upbitSectionStyle;
    case 'binance':
      return binanceSectionStyle;
    case 'ibkr':
      return ibkrSectionStyle;
    case 'bithumb':
      return bithumbSectionStyle;
  }
}

export function exchangeTitleStyle(theme: ExchangeTheme): React.CSSProperties {
  switch (theme) {
    case 'kiwoom':
      return kiwoomH2;
    case 'upbit':
      return upbitH2;
    case 'binance':
      return binanceH2;
    case 'ibkr':
      return ibkrH2;
    case 'bithumb':
      return bithumbH2;
  }
}
